import { CONSTANTS } from './constants';
import { ENV } from './env';

/**
 * Subscription management lives in the web app, next to the cancellation flow.
 * Built from ENV so dev/stage/prod each point at their own domain.
 */
export const ACCOUNT_SETTINGS_LINK = `${ENV.LIFT_WEB_APP_URL}/cancel-subscription/subscription-list`;
export const SUPPORT_MAIL_LINK = `mailto:${CONSTANTS.SUPPORT_MAIL_ADDRESS}`;
